import { useTranslation } from 'libs/i18n'
import { useUserRoles } from 'shared/hooks'
import type { Option } from 'shared/components/ContextMenu/types'
import type { PayoutItem } from 'features/payouts/types/payouts.types'
import { usePrintPayout } from 'features/payouts/hooks/usePrintPayout'

type UseContextMenuOptionsProps = {
	onEdit: (payout: PayoutItem) => void
	onMarkAsPaid: (payout: PayoutItem) => void
}

const PAID_OR_CLOSED: PayoutItem['status'][] = ['paid', 'cancelled']

export const useContextMenuOptions = ({
	onEdit,
	onMarkAsPaid
}: UseContextMenuOptionsProps): Option[] => {
	const { t } = useTranslation()
	const { isStaff } = useUserRoles()
	const { printPayout } = usePrintPayout()

	return [
		{
			label: t('Edit'),
			action: (_id: number, payout: PayoutItem) => onEdit(payout)
		},
		{
			label: t('Print'),
			action: printPayout
		},
		...(isStaff
			? [
					{
						label: t('Mark as paid'),
						borderTop: true,
						hidden: (payout: PayoutItem) => PAID_OR_CLOSED.includes(payout.status),
						action: (_id: number, payout: PayoutItem) => onMarkAsPaid(payout)
					}
				]
			: [])
	]
}
